$(function() {

  $('.parallax').paroller();

  /* Quantity select on cart page */

  $('.js-update-cart').on('change', function (e) {

    var newQuantity = this.value;
    var index = $(this).closest('.js-cart-line-item').index();

    CartJS.updateItem(index, newQuantity);

    e.preventDefault();
  });

  /* //////////////////// */


  $('.js-property-nav').on('mouseenter', function(e) {
    $('.js-hero').hide();
    $('.js-hero-images').fadeIn();

    $('.js-property').hide();
    $('.js-property[data-property="' + $(this).data('property') + '"]').show();
  });

  $('.js-property-nav').on('mouseleave', function(e) {
    $('.js-hero-images').hide();
    $('.js-property').hide();
    $('.js-hero').fadeIn();
  });

  $('.js-open-nav').on('click', function (e) {
    $('.js-mobile-nav').show();
  });

  $('.js-close-nav').on('click', function (e) {
    $('.js-mobile-nav').hide();
  });

  setTimeout(function() {
    $('body').addClass('loaded');
  }, 800);

});
